export default "__VITE_ASSET__1A7wVNqU__"